<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/inventory/stocktransfer" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("inventory.label.EditItemSale") }}</h3>
          </li>
        </ul>
      </div>
      <ValidationObserver ref="observer">
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("stockTransfer.label.Requested Date")
                    }}<span class="required"> *</span></small
                  >
                  <datepicker
                    v-model="purchaseDate"
                    :placeholder="$t('placeholder.label.SelectDate')"
                    class="mb-2 font-semibold"
                    disabled
                  />
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Item") }}
                    <span class="required"> *</span>
                  </small>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Item')"
                  >
                    <v-select
                      label="item"
                      v-model="selectedItem"
                      :options="itemList"
                      @input="selectedFirstItems(selectedItem)"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-2"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.From_ORG") }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.FromOrganization')"
                  >
                    <vue-simple-suggest
                      v-model="fromOffice"
                      value-attribute="id"
                      display-attribute="externalId"
                      :list="getMrnTrue"
                      class="w-full font-normal"
                      :filter-by-query="true"
                    >
                      <div slot="suggestion-item" slot-scope="{ suggestion }">
                        <span @click="changeCollectiontrue(suggestion)"
                          >{{ suggestion.name }} -- {{ suggestion.externalId }}
                        </span>
                      </div>
                    </vue-simple-suggest>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.To_ORG") }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.ToOrganization')"
                  >
                    <vue-simple-suggest
                      v-model="toOffice"
                      value-attribute="id"
                      display-attribute="externalId"
                      :list="getMrnFalse"
                      class="w-full font-normal"
                      :filter-by-query="true"
                    >
                      <div slot="suggestion-item" slot-scope="{ suggestion }">
                        <span @click="changeCollectionfalse(suggestion)"
                          >{{ suggestion.name }} -- {{ suggestion.externalId }}
                        </span>
                      </div>
                    </vue-simple-suggest>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Charge") }}
                    <span class="required"> *</span>
                  </small>
                  <v-select
                    label="item"
                    v-model="selectedCharge"
                    :options="chargeList"
                    @input="selectedItems(selectedCharge)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="mb-2"
                    disabled
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('inventory.label.RequestedQuantity')"
                >
                  <vs-input
                    :label="$t('inventory.label.RequestedQuantity')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="orderQuantity"
                    type="number"
                    @input="orderQuantityChange"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('inventory.label.UnitPrice')"
                >
                  <vs-input
                    :label="$t('inventory.label.UnitPrice')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="unitPrice"
                    @input="orderQuantityChange"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <vs-input
                  :label="$t('inventory.label.TotalItemPrice')"
                  class="w-full mb-4 font-semibold"
                  v-model="chargeAmount"
                  disabled
                />
              </div>
              <!-- <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{ $t("Discount Type") }}</small>
                <v-select
                  label="item"
                  v-model="Percentage"
                  :options="percentageOption"
                  placeholder="--Select One--"
                  class="mb-2"
                  disabled
                >
                </v-select>
              </div>
            </div> -->
              <!-- <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('Discount Rate')"
                class="w-full mb-2 font-semibold"
                v-model="discount"
                @input="orderQuantityChange"
              />
            </div> -->
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full">
          <div class="saveCancelBtn mb-3">
            <vs-button type="border" @click="backToGoods"
              >{{ $t("stockTransfer.label.Cancel") }}
            </vs-button>
            <vs-button @click="updateItemSale">{{
              $t("inventory.label.Submit")
            }}</vs-button>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import {
  itemSaleTemplateResource,
  getMrnFalse,
  getMrnTrue,
  getOneTimeSaleItem,
  getTotalPricePost,
  postEditItemSale,
  getBySalesId,
} from "@/http/inventory";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data() {
    return {
      purchaseDate: "",
      chargeCode: "",
      itemId: 0,
      unitPrice: 0,
      // itemSelect: "",
      // officeDatas: [],
      itemDatas: [],
      chargeDatas: {},
      itemSales: {},
      onetimesalesItem: {},
      chargeList: [],
      itemList: [],
      fromOffice: "",
      purchaseFrom: 0,
      purchaseBy: 0,
      toOffice: "",
      selectedCharge: "",
      selectedItem: "",
      Percentage: "Percentage",
      percentageOption: ["Percentage"],
      orderQuantity: "",
      PriceData: "",
      chargeAmount: "",
      discount: "",
      currencyId: "",
      itemSaleId: {},
      idMrnTrue: "",
      idMrnFalse: "",
      editItemId: "",
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    VueSimpleSuggest,
    moment,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {},

  methods: {
    async getBySalesId() {
      try {
        const response = await getBySalesId(this.$route.params.id);
        this.itemSaleId = response.data;
        this.purchaseDate = Date(this.itemSaleId.requestedDate);
        this.selectedItem = this.itemSaleId.itemDescription;
        this.fromOffice = this.itemSaleId.fromOffice;
        this.toOffice = this.itemSaleId.toOffice;

        this.orderQuantity = this.itemSaleId.orderdQuantity;
        this.chargeAmount = this.itemSaleId.chargeAmount;
        this.unitPrice = this.itemSaleId.unitPrice;
      } catch (error) {
        console.log(
          "something went to wrong while retrieving job by id:",
          error
        );
      }
    },
    async itemSaleTemplateResource() {
      try {
        const response = await itemSaleTemplateResource();
        this.itemSales = response.data;

        this.chargeList.push(
          this.itemSales.chargeDatas[0].chargeCode +
            "--" +
            this.itemSales.chargeDatas[0].chargeDescription
        );
        this.selectedCharge =
          this.itemSales.chargeDatas[0].chargeCode +
          "--" +
          this.itemSales.chargeDatas[0].chargeDescription;
        this.chargeCode = this.itemSales.chargeDatas[0].chargeCode;

        let mrnTrueData = this.itemSales.officeDatas.filter(
          (item) => item.name == this.fromOffice
        );
        this.idMrnTrue = mrnTrueData[0].id;

        let mrnFalseData = this.itemSales.officeDatas.filter(
          (item) => item.name == this.toOffice
        );
        this.idMrnFalse = mrnFalseData[0].id;
        this.itemSales.itemDatas.map((e) => {
          this.editItemId = e.id;
        });
      } catch (e) {
        console.log("something went to wrong while details:", e);
      }
    },

    async getMrnTrue() {
      try {
        const response = await getMrnTrue(this.fromOffice);
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    async getMrnFalse() {
      try {
        const response = await getMrnFalse(this.toOffice);
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    changeCollectiontrue(e) {
      this.purchaseFrom = e.id;
    },
    changeCollectionfalse(e) {
      this.purchaseBy = e.id;
    },

    async selectedFirstItems(off) {
      this.itemSales.itemDatas.map((e) => {
        if (e.itemCode + " -- " + e.itemDescription == off) {
          this.itemId = e.id;
        }
      });
      try {
        const response = await getOneTimeSaleItem(this.itemId);
        this.onetimesalesItem = response.data;
        this.unitPrice = response.data.unitPrice;
        this.chargeList.push(
          this.onetimesalesItem.chargesData[0].chargeCode +
            "--" +
            this.onetimesalesItem.chargesData[0].chargeDescription
        );
        this.selectedCharge =
          this.onetimesalesItem.chargesData[0].chargeCode +
          "--" +
          this.onetimesalesItem.chargesData[0].chargeDescription;
        this.chargeCode = this.onetimesalesItem.chargesData[0].chargeCode;
      } catch (error) {
        console.log(
          "something went to wrong while retrieving entity city:",
          error
        );
      }
    },
    async orderQuantityChange() {
      let payload = {
        data: {
          locale: "en",
          quantity: this.orderQuantity,
          unitPrice: this.onetimesalesItem.unitPrice,
        },
        id: this.onetimesalesItem.id,
      };
      this.PriceData = await getTotalPricePost(payload);
      this.chargeAmount = this.PriceData.data.totalPrice;
      this.currencyId = this.PriceData.data.currencyId;
      if (this.discount != "") {
        let discountAmount = (this.chargeAmount * this.discount) / 100;
        this.chargeAmount = this.chargeAmount - discountAmount;
      }
    },
    backToGoods() {
      this.$router.push("/inventory/stocktransfer");
    },
    async updateItemSale() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const formattedDate = moment(this.purchaseDate, "YYYY-MM-DD").format(
        "DD MMMM YYYY"
      );
      this.itemSales.itemDatas.map((e) => {
        if (e.itemDescription == this.selectedItem) {
          this.itemId = e.id;
        }
      });
      let payload = {
        itemId: Number(this.itemId),
        unitPrice: this.unitPrice.toString(),
        itemDescription: this.itemSaleId.itemDescription,
        chargeCode: this.chargeCode,
        purchaseFrom: this.idMrnTrue,
        purchaseBy: this.idMrnFalse,
        orderQuantity: this.orderQuantity.toString(),
        chargeAmount: this.chargeAmount.toString(),
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        purchaseDate: formattedDate,
      };
      await postEditItemSale(this.$route.params.id, payload);
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Item Sale Edited Successfully!",
        type: "success",
      });
      itemSaleTemplateResource();
      this.$router.push("/inventory/stocktransfer");
    },
  },
  watch: {
    itemSales(val) {
      for (let role of val.itemDatas) {
        this.itemList.push(role.itemCode + " -- " + role.itemDescription);
      }
    },
    discount(val) {
      if (val == "") {
      } else {
        let discountAmount = (this.chargeAmount * this.discount) / 100;
        this.chargeAmount = this.chargeAmount - discountAmount;
      }
    },
    orderQuantity(val) {
      if (val == "") {
        this.chargeAmount = 0;
      } else {
        this.chargeAmount = this.unitPrice * Number(val);
      }
    },
    unitPrice(val) {
      if (val == "") {
        this.chargeAmount = 0;
      } else {
        this.chargeAmount = this.orderQuantity * Number(val);
      }
    },
  },

  mounted() {
    this.itemSaleTemplateResource();
    this.getBySalesId();
    this.getMrnTrue();
    this.getMrnFalse();
  },
};
</script>
<style scoped></style>
